import { Outlet, Navigate } from 'react-router-dom';
import { useSession } from '../context/session-context';
import Header from '../components/layout/header';
import Sidebar from '../components/layout/sidebar';
import { LoadingSpinner } from '../components/ui/loading-spinner';
import { useEffect, useState } from 'react';
import supabase from '../supabase';
import { ROLE_ID } from '../constants/roles';

const AuthProtectedRoute = () => {
  const { session } = useSession();
  const [authorized, setAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const checkAccess = async () => {
      if (!session) {
        setAuthorized(false);
        setLoading(false);
        setAuthChecked(true);
        return;
      }

      try {
        const { data } = await supabase
          .from('users')
          .select('role_id')
          .eq('auth_id', session.user.id)
          .single();

        setAuthorized(
          data?.role_id === ROLE_ID.SUPER_ADMIN ||
            data?.role_id === ROLE_ID.ADMIN,
        );
      } catch (error) {
        setAuthorized(false);
      } finally {
        setLoading(false);
        setAuthChecked(true);
      }
    };

    checkAccess();
  }, [session]);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (authChecked && (!session || !authorized)) {
    if (session) {
      supabase.auth.signOut();
    }
    return <Navigate to="/sign-in" replace />;
  }

  return (
    <div className="min-h-screen">
      <Header />
      <div className="flex pt-16">
        <Sidebar />
        <main className="flex-1 ml-64 p-6 overflow-auto h-[calc(100vh-64px)]">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AuthProtectedRoute;
